<template>
    <v-row align="center">
        <v-col>
            <v-row class="row--small" align="center">
                <v-col cols="12" md="">
                    <v-select v-model="form.workExperience.items" :items="workExperiences" :menuProps="{ attach: `.form-qualification-experience-${className}` }" :class="`form-qualification-experience-${className}`" :disabled="form.workExperience.isIrrelevant" multiple outlined attach @input="emit" />
                </v-col>
                <v-col cols="12" md="">
                    <v-currency-field v-model="form.workExperience.years" :disabled="form.workExperience.isIrrelevant" outlined suffix="년 " class="text-right" @input="emit" />
                </v-col>
                <v-col cols="12" md="">
                    <v-currency-field v-model="form.workExperience.months" :disabled="form.workExperience.isIrrelevant" outlined suffix="개월" :max="11" class="text-right" @input="emit" />
                </v-col>
                <v-col cols="12" md="auto"> 이상 </v-col>
            </v-row>
        </v-col>
        <v-col cols="auto">
            <v-switch v-model="form.workExperience.isIrrelevant" label="경력무관" dense inset hide-details @change="onChangeIsIrrelevant" />
        </v-col>
    </v-row>
</template>

<script>
import { initRecruitmentField__qualification, WORK_EXPERIENCES } from "@/assets/variables";

const workExperiences = Object.values(WORK_EXPERIENCES);

export default {
    props: {
        value: { type: Object, default: initRecruitmentField__qualification },
    },
    data: () => ({
        form: initRecruitmentField__qualification(),
        workExperiences,

        className: Math.random().toString().slice(2),
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = initRecruitmentField__qualification(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        onChangeIsIrrelevant() {
            this.form.workExperience.items = [];
            this.form.workExperience.years = 0;
            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
.row--small {
    margin: -5px -2px;
    > [class*="col"] {
        padding: 5px 2px;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .row--small {
        margin: -5px;
        > [class*="col"] {
            padding: 5px;
        }
    }
}
@media (min-width: 1200px) {
}
</style>